export default {
  currentUser: state => state.user,
  currentEmployee: state => state.employee,
  currentEmployeeBranch: state => state.employee.company_branch,
  currentEmployeePhone: state => state.employee.phone_number,
  currentUserBankCard: state => state.user.bank_card,
  currentUserBankAccount: state => state.user.bank_account,
  currentRoles: state => state.user.roles,
  isAuthenticated: state => state.isAuthenticated
}
